var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      ref: "generalHolder",
      staticClass: "rb-header__side-panel",
      class: {
        "rb-header__side-panel--mobile": _vm.isMobile,
        "rb-header__side-panel--visible": _vm.isOpen,
      },
      style: _vm.adjustedStyle,
      on: {
        keydown: function ($event) {
          if (
            !$event.type.indexOf("key") &&
            _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])
          ) {
            return null
          }
          return _vm.emitOverlayClick(false)
        },
      },
    },
    [
      _c(
        "div",
        {
          staticClass: "side-panel__wrapper",
          style: { zIndex: "" + (_vm.zIndex + 1) },
        },
        [
          _vm.canShowHeader
            ? _c("div", { staticClass: "side-panel__header" }, [
                _c("div", { staticClass: "side-panel__section--left" }, [
                  _c(
                    "button",
                    {
                      attrs: { "aria-label": "back" },
                      on: { click: _vm.emitBack },
                    },
                    [
                      _c("rb-lazy-icon", {
                        attrs: { icon: "caret-big-left", text: "back" },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "section__header",
                      class: {
                        "section__header--non-clickable":
                          _vm.panelHeaderIsDisabled,
                      },
                    },
                    [_vm._t("header")],
                    2
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "span",
                  {
                    staticClass: "common__icon common__icon--close-bold",
                    on: { click: _vm.emitClose },
                  },
                  [_vm._v("close")]
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "side-panel__content" },
            [_vm._t("content")],
            2
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "wcag-hidden-button",
          attrs: { tabindex: _vm.wcagButtonTabIndex },
          on: {
            focus: function ($event) {
              return _vm.emitOverlayClick(true)
            },
          },
        },
        [_vm._v("\n    Side Panel cta\n  ")]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }